export default __webpack_public_path__ + "static/media/CORE_gltd_c1.71a1fbee.png";